(function () {
'use strict';
var VL = window.VL, D = window.VLD && VLD.medita; if (!VL || !D) return;
var h = VL.h;
function lat1(s) { return String(s).replace(/[^\u0000-ÿ–—‘’“”•…€]/g, function (ch) { return ch.normalize('NFD').replace(/[̀-ͯ]/g, ''); }); }
function vtxt(it) { return typeof it.verse === 'number' ? 'verso ' + it.verse : 'verso pendiente de identificar'; }
function fmtScript(s) { return s.replace(/\[pausa larga\]/g, '(pausa larga)').replace(/\[pausa ([^\]]+)\]/g, '(pausa de $1)'); }
VL.register('medita', {
mount: function (mount, ctx) {
var root = ctx.root, c = ctx.c;
var st = { q: '', cat: '', level: '', limb: '', fav: false };
function limbList(it) { return (it.limbsRel || []).map(function (x) { var L = D.limbs[x.k]; return L.n + ' (' + L.es.toLowerCase() + '): ' + x.why; }); }
var favs = VL.store.get('medita-fav', []) || [];
var log = VL.store.get('medita-log', {}) || {};
function isFav(id) { return favs.indexOf(id) >= 0; }
function toggleFav(id) { if (isFav(id)) favs = favs.filter(function (x) { return x !== id; }); else favs.push(id); VL.store.set('medita-fav', favs); }
function today() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
function norm(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
function byId(id) { for (var i = 0; i < D.items.length; i++) if (D.items[i].id === id) return D.items[i]; return null; }

function list() {
  VL.clear(mount);
  var intro = h('div', { class: 'vl-panel' },
    h('p', { class: 'vl-lead', text: 'Una biblioteca abierta de prácticas de atención basadas en el Vijñāna Bhairava Tantra. Puedes explorarla sin registrarte. Esta primera entrega incluye ' + D.items.length + ' de las 112 técnicas; el resto se publicará después de revisarlas.' }),
    h('details', { class: 'vl-gloss' }, h('summary', { text: 'Sobre el texto y las fuentes' }), h('p', { text: D.context }), h('p', { text: D.source.edition }), h('p', { class: 'vl-note', text: D.source.status })),
    h('details', { class: 'vl-gloss' }, h('summary', { text: 'Las ramas del yoga en esta biblioteca' }), h('p', { class: 'vl-note', text: D.limbsNote }), h('dl', null, Object.keys(D.limbs).map(function (k) { return [h('dt', { text: D.limbs[k].n + ' · ' + D.limbs[k].es }), h('dd', { text: D.limbs[k].d })]; }).reduce(function (x, y) { return x.concat(y); }, []))),
    h('p', { class: 'vl-note', text: D.disclaimer }));
  mount.appendChild(intro);
  var qid = VL.uid('q'), cid = VL.uid('c'), lid = VL.uid('l'), fid = VL.uid('f');
  var q = h('input', { type: 'search', id: qid, value: st.q, placeholder: 'Respiración, sonido, cielo…', oninput: function () { st.q = q.value; draw(); } });
  var cs = h('select', { id: cid, onchange: function () { st.cat = cs.value; draw(); } }, h('option', { value: '', text: 'Todas las categorías' }));
  Object.keys(D.cats).forEach(function (k) { var o = h('option', { value: k, text: D.cats[k] }); if (st.cat === k) o.selected = true; cs.appendChild(o); });
  var ls = h('select', { id: lid, onchange: function () { st.level = ls.value; draw(); } }, h('option', { value: '', text: 'Todos los niveles' }));
  Object.keys(D.levels).forEach(function (k) { var o = h('option', { value: k, text: D.levels[k] }); if (st.level === k) o.selected = true; ls.appendChild(o); });
  var yid = VL.uid('y');
  var ys = h('select', { id: yid, onchange: function () { st.limb = ys.value; draw(); } }, h('option', { value: '', text: 'Todas las ramas' }));
  Object.keys(D.limbs).forEach(function (k) { var o = h('option', { value: k, text: D.limbs[k].n + ' · ' + D.limbs[k].es }); if (st.limb === k) o.selected = true; ys.appendChild(o); });
  var fv = h('input', { type: 'checkbox', id: fid, checked: st.fav, onchange: function () { st.fav = fv.checked; draw(); } });
  var filters = h('div', { class: 'vl-panel' },
    h('div', { class: 'vl-row' },
      h('div', { class: 'vl-field' }, h('label', { for: qid, text: 'Buscar' }), q),
      h('div', { class: 'vl-field' }, h('label', { for: cid, text: 'Categoría' }), cs),
      h('div', { class: 'vl-field' }, h('label', { for: lid, text: 'Nivel' }), ls),
      h('div', { class: 'vl-field' }, h('label', { for: yid, text: 'Rama del yoga' }), ys)),
    h('div', { class: 'vl-field' }, h('label', { for: fid }, fv, ' Solo mis favoritas (guardadas en este dispositivo)')),
    h('p', { class: 'vl-note', text: D.catNote }));
  mount.appendChild(filters);
  var res = h('div', { 'aria-live': 'polite' });
  mount.appendChild(res);
  function draw() {
    VL.clear(res);
    var nq = norm(st.q.trim());
    var items = D.items.filter(function (it) {
      if (st.cat && it.cat !== st.cat) return false;
      if (st.level && String(it.level) !== st.level) return false;
      if (st.fav && !isFav(it.id)) return false;
      if (st.limb && !(it.limbsRel || []).some(function (x) { return x.k === st.limb; })) return false;
      if (nq && norm([it.title, it.simple, it.meaning, D.cats[it.cat]].join(' ')).indexOf(nq) < 0) return false;
      return true;
    });
    res.appendChild(h('p', { class: 'vl-note', text: items.length + (items.length === 1 ? ' técnica' : ' técnicas') }));
    if (!items.length) { res.appendChild(h('p', { class: 'vl-alert vl-alert--info', text: 'No hay técnicas con estos filtros.' })); return; }
    var grid = h('div', { class: 'vl-xlist' });
    items.forEach(function (it) {
      grid.appendChild(h('article', { class: 'vl-x' },
        h('div', { class: 'vl-x__head' },
          h('div', null, h('p', { class: 'vl-x__trad', text: 'Ficha ' + it.n + ' · ' + vtxt(it) + ' · ' + D.cats[it.cat] }), h('h3', { class: 'vl-x__title', text: it.title })),
          h('div', { class: 'vl-x__tags' }, h('span', { class: 'vl-tag vl-tag--na', text: D.levels[it.level] }), isFav(it.id) ? h('span', { class: 'vl-tag vl-tag--ok', text: '★ Favorita' }) : null)),
        h('p', { text: it.simple }),
        h('p', { class: 'vl-note', text: 'Yoga: ' + (it.limbsRel || []).map(function (x) { return D.limbs[x.k].n; }).join(' · ') }),
        h('p', { class: 'vl-note', text: 'Duración orientativa: ' + it.min.join(', ') + ' min' }),
        h('div', { class: 'vl-actions' }, h('a', { class: 'vl-btn vl-btn--sm', href: '#' + it.id }, 'Ver la práctica'))));
    });
    res.appendChild(grid);
  }
  draw();
}

function timerBox(it) {
  var box = h('div', { class: 'vl-panel vl-panel--cream' });
  var mins = it.min[0], left = mins * 60, tid = null;
  var disp = h('p', { class: 'vl-kpi', style: 'font-size:2rem;text-align:center', 'aria-live': 'off' });
  var msg = h('p', { class: 'vl-note', role: 'status' });
  function show() { disp.textContent = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2); }
  function stop() { if (tid) { clearInterval(tid); tid = null; } }
  var sel = h('select', { onchange: function () { stop(); mins = Number(sel.value); left = mins * 60; show(); msg.textContent = ''; } });
  it.min.forEach(function (m) { sel.appendChild(h('option', { value: String(m), text: m + ' min' })); });
  var sid = VL.uid('t'); sel.id = sid;
  box.appendChild(h('h3', { text: 'Temporizador' }));
  box.appendChild(h('p', { class: 'vl-note', text: 'Temporizador silencioso: no reproduce audio. Al terminar muestra un aviso en pantalla.' }));
  box.appendChild(h('div', { class: 'vl-field' }, h('label', { for: sid, text: 'Duración' }), sel));
  box.appendChild(disp);
  box.appendChild(h('div', { class: 'vl-actions' },
    h('button', { type: 'button', class: 'vl-btn', onclick: function () { if (tid) return; msg.textContent = ''; tid = setInterval(function () { left--; show(); if (left <= 0) { stop(); msg.textContent = 'Tiempo cumplido. Termina con calma.'; VL.announce(root, 'Tiempo cumplido', 'ok'); } }, 1000); } }, 'Empezar'),
    h('button', { type: 'button', class: 'vl-btn vl-btn--ghost', onclick: stop }, 'Pausa'),
    h('button', { type: 'button', class: 'vl-btn vl-btn--ghost', onclick: function () { stop(); left = mins * 60; show(); msg.textContent = ''; } }, 'Reiniciar')));
  box.appendChild(msg);
  show();
  window.addEventListener('hashchange', stop, { once: true });
  return box;
}

function detail(it) {
  VL.clear(mount);
  var top = h('div', { class: 'vl-actions' }, h('a', { class: 'vl-btn vl-btn--ghost vl-btn--sm', href: '#' }, '← Volver a la biblioteca'));
  mount.appendChild(top);
  var p = h('div', { class: 'vl-panel' });
  p.appendChild(h('p', { class: 'vl-eyebrow', text: 'Ficha ' + it.n + ' · ' + vtxt(it) + ' del texto · ' + it.id.toUpperCase() }));
  var title = h('h2', { tabindex: '-1', text: it.title });
  p.appendChild(title);
  p.appendChild(h('p', null, h('span', { class: 'vl-tag vl-tag--na', text: D.cats[it.cat] }), ' ', h('span', { class: 'vl-tag vl-tag--na', text: D.levels[it.level] }), ' ', h('span', { class: 'vl-tag vl-tag--na', text: it.min.join(', ') + ' min' })));
  p.appendChild(h('p', { class: 'vl-lead', text: it.simple }));
  var favB = h('button', { type: 'button', class: 'vl-btn vl-btn--ghost vl-btn--sm', 'aria-pressed': isFav(it.id) ? 'true' : 'false', onclick: function () { toggleFav(it.id); favB.setAttribute('aria-pressed', isFav(it.id) ? 'true' : 'false'); favB.textContent = isFav(it.id) ? '★ En favoritas' : '☆ Guardar en favoritas'; } }, isFav(it.id) ? '★ En favoritas' : '☆ Guardar en favoritas');
  var done = log[it.id] || [];
  var logNote = h('span', { class: 'vl-note', text: done.length ? 'Practicada ' + done.length + (done.length === 1 ? ' vez' : ' veces') + ' · última: ' + done[done.length - 1] : '' });
  var logB = h('button', { type: 'button', class: 'vl-btn vl-btn--ghost vl-btn--sm', onclick: function () { var d = log[it.id] || []; d.push(today()); log[it.id] = d.slice(-60); VL.store.set('medita-log', log); logNote.textContent = 'Practicada ' + d.length + (d.length === 1 ? ' vez' : ' veces') + ' · última: ' + d[d.length - 1]; VL.announce(root, 'Práctica anotada', 'ok'); } }, '✓ Anotar práctica de hoy');
  p.appendChild(h('div', { class: 'vl-actions' }, favB, logB, h('button', { type: 'button', class: 'vl-btn vl-btn--sm', onclick: function () { pdf(it); } }, c('pdf'))));
  p.appendChild(h('p', null, logNote));
  p.appendChild(h('p', { class: 'vl-note', text: 'Favoritas y registro se guardan solo en este navegador. La cuenta gratuita para guardarlos en cualquier dispositivo llegará en una fase posterior.' }));
  mount.appendChild(p);

  var cards = [
    { title: 'Significado tradicional', kind: 'trad', meaning: it.meaning, why: it.original + ' Fuente: ' + D.source.text + ', ' + vtxt(it) + (typeof it.verse === 'number' ? ' (numeración de la edición de referencia). ' : '. ') + D.source.edition + ' ' + D.source.status },
    { title: 'Contexto histórico y filosófico', kind: 'trad', meaning: D.context },
    { title: 'Práctica paso a paso', kind: 'mixed', meaning: it.steps, forMe: 'Preparación del cuerpo y del ambiente: ' + it.prep, why: 'Adaptación para principiantes: ' + it.beginner, example: 'En casa: ' + it.home + ' En el trabajo: ' + it.work, todo: ['Duración orientativa: ' + it.min.join(', ') + ' minutos.', 'Nivel: ' + D.levels[it.level] + '.'], open: true },
    { title: 'Precauciones y alternativas', kind: 'fact', meaning: it.caution, forMe: D.disclaimer },
    { title: 'Relación con el yoga', trad: (it.limbsRel || []).map(function (x) { return D.limbs[x.k].n; }).join(' · '), kind: 'mixed', meaning: limbList(it), forMe: it.yoga + ' ' + it.daily, why: D.limbsNote, example: (it.limbsRel || []).map(function (x) { var L = D.limbs[x.k]; return L.n + ': ' + L.d; }) }
  ];
  mount.appendChild(VL.explainList(cards, 'es'));
  mount.appendChild(timerBox(it));

  var g = h('div', { class: 'vl-panel' });
  g.appendChild(h('h3', { text: 'Guion de práctica guiada' }));
  g.appendChild(h('p', { class: 'vl-note', text: 'Texto preparado para leer en voz alta o para una futura narración. Aún no hay audio grabado. Las pausas indican cuánto esperar en silencio.' }));
  var ol = h('ol', { class: 'vl-plansteps' });
  it.script.forEach(function (s) { ol.appendChild(h('li', { text: fmtScript(s) })); });
  g.appendChild(ol);
  g.appendChild(h('h3', { text: 'Reflexión posterior' }));
  g.appendChild(h('p', { text: it.reflection }));
  g.appendChild(h('h3', { text: 'Preguntas para tu diario' }));
  var ul = h('ul', { class: 'vl-checklist' }); it.journal.forEach(function (x) { ul.appendChild(h('li', { text: x })); }); g.appendChild(ul);
  mount.appendChild(g);
  title.focus();
}

function pdf(it) {
  try {
    var pc = VL.translator(VL.COMMON, 'es');
    var doc = new VL.PDFDoc({ title: 'Biblioteca de meditaciones', footer: pc('disclaimerShort'), pageLabel: pc('page') });
    var txt0 = doc.txt; doc.txt = function (x, y, s, size, bold, rgb) { return txt0.call(this, x, y, lat1(s), size, bold, rgb); };
    doc.h1(it.title);
    doc.p('Ficha ' + it.n + ' · ' + vtxt(it) + ' · ' + it.id.toUpperCase(), { size: 9.5, bold: true });
    doc.p(D.cats[it.cat] + ' · ' + D.levels[it.level] + ' · ' + it.min.join(', ') + ' min · ' + pc('generated', { date: VL.fmtDate(new Date(), 'es') }), { size: 9.5, rgb: '0.35 0.38 0.45' });
    doc.p(it.simple);
    doc.h2('Significado tradicional'); doc.p(it.meaning);
    doc.h2('Fuente'); doc.p(D.source.text + ', ' + vtxt(it) + '. ' + D.source.edition, { size: 9.5 }); doc.p(D.source.status, { size: 9, rgb: '0.35 0.38 0.45' });
    doc.h2('Preparación'); doc.p(it.prep);
    doc.h2('Práctica paso a paso'); doc.bullets(it.steps.map(function (s, i) { return (i + 1) + '. ' + s; }));
    doc.h2('Para principiantes'); doc.p(it.beginner);
    doc.h2('Precauciones'); doc.box(it.caution);
    doc.h2('Relación con el yoga'); doc.bullets(limbList(it)); doc.p(D.limbsNote, { size: 9, rgb: '0.35 0.38 0.45' });
    doc.h2('En la vida diaria'); doc.p(it.daily + ' En casa: ' + it.home + ' En el trabajo: ' + it.work);
    doc.h2('Guion de práctica guiada'); doc.bullets(it.script.map(fmtScript), { size: 9.5 });
    doc.h2('Reflexión y diario'); doc.p(it.reflection); doc.bullets(it.journal);
    doc.h2('Contexto'); doc.p(D.context, { size: 9.5 });
    doc.box(D.disclaimer);
    VL.downloadPDF(doc, 'meditacion-' + it.id + '.pdf');
    VL.announce(root, c('pdfOk'), 'ok');
  } catch (e) { if (window.console) console.error(e); VL.announce(root, c('pdfFail'), 'error'); }
}

function route() {
  var id = (location.hash || '').slice(1);
  var it = id ? byId(id) : null;
  if (it) detail(it); else list();
}
window.addEventListener('hashchange', route);
route();
}
});
if (VL.boot) VL.boot();
})();
